module.exports = __webpack_public_path__ + "images/8e15b5e23b2a46d2f31e357801c79293bef0549c9ebe6aa50c813857b8479c0c.svg";